import { mergeRight } from 'ramda';
import { createAction } from 'redux-actions';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';

import fetch from 'features/common/fetch';
import { saveFile } from 'features/common/fileSave/actions';
import { resetErrorsByPage } from 'features/common/submitFormDialog/slice';
import { getSellers } from 'features/other/organizationStructureMUI/seller/selectors';
import { trimFormData } from 'utils';

import actionTypes from './actionTypes';
import { PAGE_SIZE } from './constants';
import { TASK_STATISTICS_FORM_NAME } from './form';
import { requestFactory } from './utils';

const setData = createAction(actionTypes.SET_TABLE_DATA, (type, data) => ({ type, data }));
const appendData = createAction(actionTypes.APPEND_TABLE_DATA, (type, data) => ({ type, data }));
const removeTable = createAction(actionTypes.REMOVE_TABLE);

const handleResponse =
	({ response, append }) =>
	async (dispatch, getState, { getFormData }) => {
		if (!response || !response.body) {
			return;
		} else {
			const formData = await getFormData(TASK_STATISTICS_FORM_NAME);
			const statType = formData?.statType;

			dispatch(resetErrorsByPage({ page: TASK_STATISTICS_FORM_NAME }));
			dispatch(append ? appendData(statType, response.body.data) : setData(statType, response.body.data));
		}
	};

export const resetPage =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		sendControlNext(TASK_STATISTICS_FORM_NAME, resetForm());
		dispatch(removeTable());
		dispatch(resetErrorsByPage({ page: TASK_STATISTICS_FORM_NAME }));
	};

export const search =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(TASK_STATISTICS_FORM_NAME);
		const formData = trimFormData(data);
		const allSellers = getSellers(getState(), formData);

		const response = await dispatch(
			fetch.actions.post(fetch.constants.urls.taskStatistics, {
				takeLatest: true,
				queryParams: { size: PAGE_SIZE, page: 0 },
				body: requestFactory(formData, allSellers),
			}),
		);

		dispatch(handleResponse({ response, append: false }));
	};

export const exportStatistics =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(TASK_STATISTICS_FORM_NAME);
		const formData = trimFormData(data);
		const allSellers = getSellers(getState(), formData);

		const response = await dispatch(
			fetch.actions.postBinary(fetch.constants.urls.taskStatisticsExport, {
				body: requestFactory(formData, allSellers),
			}),
		);

		saveFile({ response });
	};

export const loadMore = () => (dispatch, getState) => {
	const state = getState();
	const { queryParams, body } = fetch.selectors.getLastRequest(fetch.constants.urls.taskStatistics)(state);

	dispatch(
		fetch.actions.post(fetch.constants.urls.taskStatistics, {
			queryParams: mergeRight(queryParams, { page: queryParams?.page + 1 }),
			body,
		}),
	).then((response) => {
		dispatch(handleResponse({ response, append: true }));
	});
};

export const paginationClick = (page) => (dispatch, getState) => {
	const state = getState();
	const { queryParams, body } = fetch.selectors.getLastRequest(fetch.constants.urls.taskStatistics)(state);

	dispatch(
		fetch.actions.post(fetch.constants.urls.taskStatistics, {
			queryParams: mergeRight(queryParams, { page }),
			body,
		}),
	).then((response) => {
		dispatch(handleResponse({ response, append: false }));
	});
};
